import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=1ee07106"
import script from "./edit.vue?vue&type=script&setup=true&lang=ts"
export * from "./edit.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.26.0__cache-loader@4.1.0_webpack@4_duly6tfyc62fvcli236pnhbyri/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./edit.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IxBtnBack: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/btn/Back.vue').default,IxFormInputQuestion: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/form-input/Question.vue').default,IxTextField: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/TextField.vue').default,IxAutocompleteStakeholderType: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/autocomplete/StakeholderType.vue').default,IxTextarea: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/Textarea.vue').default,IxDataTableIroSectionLink: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/data-table/IroSectionLink.vue').default,IxBtnAddActivity: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/btn/AddActivity.vue').default,IxDataTableActivity: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/data-table/Activity.vue').default,IxBtnAddIro: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/btn/AddIro.vue').default,IxDataTableIro: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/data-table/Iro.vue').default})
